import { StateNames } from '#shared/statics.ts';

export default defineNuxtPlugin(async (nuxtApp) => {
    if (!nuxtApp.payload.serverRendered) {
        useState<NeoSession>(StateNames.NEO_SESSION).value = await $fetch<NeoSession>('/api/user/getNeoSession');
        useState<AppUserProfile>(StateNames.APP_USER_PROFILE).value = await $fetch<AppUserProfile>('/api/user/getProfileData');
        useState<AppUserSession>(StateNames.APP_USER_SESSION).value = await $fetch<AppUserSession>('/api/user/getAppUserSession');
    }
});
